import axios from "axios";

export default function OfferDownloadService(offerId, format) {
  return axios.get(process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/download/" + format, {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
